'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("tlModulePlacement", function () {
  return {
    restrict: "E",
    replace: true,
    scope: true,
    template: "<span tl-tooltip=\"Placement\" class=\"mr-s module-placement\">Pl</span>"
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/modules/tl-module-placement.js
// module id = 2861
// module chunks = 13